import { Typography } from "@mui/material";

const Created = ({ created, locale, fontSize }) => {
  const dt = new Date(created);

  return (
    <Typography {...{ fontSize, sx: { cursor: "default" } }}>
      {dt.toLocaleString(locale)}
    </Typography>
  );
};

export default Created;
